import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expandable"
export default class extends Controller {
  static targets = ["content", "icon", "toggleText"]
  static values = {
    defaultExpanded: { type: Boolean, default: false },
    showText: { type: String, default: "Show details" },
    hideText: { type: String, default: "Hide details" }
  }

  connect() {
    // If default expanded, expand on load
    if (this.defaultExpandedValue) {
      this.expand()
    }
  }

  toggle(event) {
    // Stop propagation to prevent card click from triggering
    if (event) {
      event.stopPropagation()
    }

    this.contentTarget.classList.toggle("hidden")

    // Rotate icon and update text
    if (this.contentTarget.classList.contains("hidden")) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove("hidden")
    this.iconTarget.style.transform = "rotate(180deg)"

    // Smart text replacement - preserve step progress if present
    const currentText = this.toggleTextTarget.textContent
    if (currentText.includes("Show steps")) {
      this.toggleTextTarget.textContent = currentText.replace("Show steps", "Hide steps")
    } else {
      this.toggleTextTarget.textContent = this.hideTextValue
    }
  }

  collapse() {
    this.contentTarget.classList.add("hidden")
    this.iconTarget.style.transform = "rotate(0deg)"

    // Smart text replacement - preserve step progress if present
    const currentText = this.toggleTextTarget.textContent
    if (currentText.includes("Hide steps")) {
      this.toggleTextTarget.textContent = currentText.replace("Hide steps", "Show steps")
    } else {
      this.toggleTextTarget.textContent = this.showTextValue
    }
  }

  stopPropagation(event) {
    // Prevent card modal from opening when clicking in steps section
    event.stopPropagation()
  }
}
